!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("prop-types"), require("react-dom"), require("classnames")) : "function" == typeof define && define.amd ? define("main", ["react", "prop-types", "react-dom", "classnames"], t) : "object" == typeof exports ? exports.main = t(require("react"), require("prop-types"), require("react-dom"), require("classnames")) : (e["react-flipcard-2"] = e["react-flipcard-2"] || {}, e["react-flipcard-2"].main = t(e.react, e["prop-types"], e["react-dom"], e.classnames));
}(this, function (e, t, r, n) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(1),
        o = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n);

    t.default = o.default;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        l = r(2),
        p = function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    }(l),
        c = r(3),
        d = n(c),
        f = r(4),
        u = r(5),
        m = n(u),
        h = r(6),
        y = n(h);

    (0, n(r(7)).default)();

    var v = function (e) {
      function t(e) {
        o(this, t);
        var r = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return b.call(r), r.state = {
          hasFocus: !1,
          isFlipped: e.flipped
        }, r;
      }

      return a(t, e), s(t, [{
        key: "componentDidMount",
        value: function value() {
          this.hideFlippedSide();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = this;
          this.showBothSides(), this.timeouts.isFlipped = setTimeout(function () {
            t.setState({
              isFlipped: e.flipped
            });
          });
        }
      }, {
        key: "componentWillUpdate",
        value: function value(e, t) {
          !this.props.flipped && e.flipped && (this.focusElement = document.activeElement, this.focusBack = !0), this.state.isFlipped !== t.isFlipped && (this.notifyFlip = !0);
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          !this.props.flipped && this.focusElement && (0, y.default)((0, f.findDOMNode)(this), document.activeElement) ? (this.focusElement.focus(), this.focusElement = null) : this.focusBack && (this.ref.back.focus(), this.focusBack = !1), this.notifyFlip && "function" == typeof this.props.onFlip && (this.props.onFlip(this.state.isFlipped), this.notifyFlip = !1), this.timeouts.hideFlipped = setTimeout(this.hideFlippedSide, 600);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          var e = !0,
              t = !1,
              r = void 0;

          try {
            for (var n, o = Object.keys(this.timeouts)[Symbol.iterator](); !(e = (n = o.next()).done); e = !0) {
              var i = n.value;
              clearTimeout(this.timeouts[i]);
            }
          } catch (e) {
            t = !0, r = e;
          } finally {
            try {
              !e && o.return && o.return();
            } finally {
              if (t) throw r;
            }
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this;
          return p.createElement("div", {
            className: (0, m.default)({
              ReactFlipCard: !0,
              "ReactFlipCard--vertical": "vertical" === this.props.type,
              "ReactFlipCard--horizontal": "vertical" !== this.props.type,
              "ReactFlipCard--flipped": this.state.isFlipped,
              "ReactFlipCard--enabled": !this.props.disabled
            }),
            tabIndex: 0,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyDown: this.props.onKeyDown
          }, p.createElement("div", {
            className: "ReactFlipCard__Flipper"
          }, p.createElement("div", {
            className: "ReactFlipCard__Front",
            ref: function ref(t) {
              e.ref.front = t;
            },
            tabIndex: -1,
            "aria-hidden": this.state.isFlipped
          }, this.props.children[0]), p.createElement("div", {
            className: "ReactFlipCard__Back",
            ref: function ref(t) {
              e.ref.back = t;
            },
            tabIndex: -1,
            "aria-hidden": !this.state.isFlipped
          }, this.props.children[1])));
        }
      }]), t;
    }(p.Component);

    v.propTypes = {
      type: d.default.string,
      flipped: d.default.bool,
      disabled: d.default.bool,
      onFlip: d.default.func,
      onKeyDown: d.default.func,
      children: function children(e, t, r) {
        var n = e[t];
        if (2 !== p.Children.count(n)) return new Error("`" + r + "` should contain exactly two children. The first child represents the front of the card. The second child represents the back of the card.");
      }
    }, v.defaultProps = {
      type: "hortizontal",
      flipped: !1,
      disabled: !1
    };

    var b = function b() {
      var e = this;
      this.timeouts = {}, this.ref = {}, this.handleFocus = function () {
        e.props.disabled || e.setState({
          isFlipped: !0
        });
      }, this.handleBlur = function () {
        e.props.disabled || e.setState({
          isFlipped: !1
        });
      }, this.hideFlippedSide = function () {
        e.props.disabled && (e.state.isFlipped ? e.ref.front.style.display = "none" : e.ref.back.style.display = "none");
      }, this.showBothSides = function () {
        e.ref.front.style.display = "", e.ref.back.style.display = "";
      };
    };

    t.default = v;
  }, function (e, t) {
    e.exports = require("react");
  }, function (e, t) {
    e.exports = require("prop-types");
  }, function (e, t) {
    e.exports = require("react-dom");
  }, function (e, t) {
    e.exports = require("classnames");
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      do {
        if (e === t) return !0;
      } while (t && (t = t.parentNode));

      return !1;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.contains = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function () {
      var e = document.getElementById("react-flipcard-style");

      if (!e) {
        e = document.createElement("style"), e.setAttribute("id", "react-flipcard-style");
        var t = document.querySelector("head");
        t.insertBefore(e, t.firstChild);
      }

      e.innerHTML = n;
    };
    var n = "\n.ReactFlipCard {\n  -webkit-perspective: 1000;\n  -moz-perspective: 1000;\n  -ms-perspective: 1000;\n  perspective: 1000;\n\n  -ms-transform: perspective(1000px);\n  -moz-transform: perspective(1000px);\n  -moz-transform-style: preserve-3d;\n  -ms-transform-style: preserve-3d;\n\n  display: inline-block;\n}\n\n/* START: Accommodating for IE */\n.ReactFlipCard--enabled.ReactFlipCard:hover .ReactFlipCard__Back,\n.ReactFlipCard--flipped .ReactFlipCard__Back {\n  -webkit-transform: rotateY(0deg);\n  -moz-transform: rotateY(0deg);\n  -ms-transform: rotateY(0deg);\n  -o-transform: rotateY(0deg);\n  transform: rotateY(0deg);\n}\n\n.ReactFlipCard--enabled.ReactFlipCard:hover .ReactFlipCard__Front,\n.ReactFlipCard--flipped .ReactFlipCard__Front {\n  -webkit-transform: rotateY(180deg);\n  -moz-transform: rotateY(180deg);\n  -ms-transform: rotateY(180deg);\n  -o-transform: rotateY(180deg);\n  transform: rotateY(180deg);\n}\n/* END: Accommodating for IE */\n\n.ReactFlipCard__Flipper {\n  -webkit-transition: 0.6s;\n  -webkit-transform-style: preserve-3d;\n  -ms-transition: 0.6s;\n\n  -moz-transition: 0.6s;\n  -moz-transform: perspective(1000px);\n  -moz-transform-style: preserve-3d;\n  -ms-transform-style: preserve-3d;\n\n  transition: 0.6s;\n  transform-style: preserve-3d;\n\n  position: relative;\n}\n\n.ReactFlipCard__Front, .ReactFlipCard__Back {\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  -ms-backface-visibility: hidden;\n  backface-visibility: hidden;\n\n  -webkit-transition: 0.6s;\n  -webkit-transform-style: preserve-3d;\n  -webkit-transform: rotateY(0deg);\n\n  -moz-transition: 0.6s;\n  -moz-transform-style: preserve-3d;\n  -moz-transform: rotateY(0deg);\n\n  -o-transition: 0.6s;\n  -o-transform-style: preserve-3d;\n  -o-transform: rotateY(0deg);\n\n  -ms-transition: 0.6s;\n  -ms-transform-style: preserve-3d;\n  -ms-transform: rotateY(0deg);\n\n  transition: 0.6s;\n  transform-style: preserve-3d;\n  transform: rotateY(0deg);\n\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ReactFlipCard__Front {\n  -webkit-transform: rotateY(0deg);\n  -moz-transform: rotateY(0deg);\n  -ms-transform: rotateY(0deg);\n  -o-transform: rotateY(0deg);\n  z-index: 2;\n}\n\n.ReactFlipCard__Back {\n  -webkit-transform: rotateY(-180deg);\n  -moz-transform: rotateY(-180deg);\n  -ms-transform: rotateY(-180deg);\n  -o-transform: rotateY(-180deg);\n    transform: rotateY(-180deg);\n}\n\n/* vertical */\n.ReactFlipCard--vertical {\n  position: relative;\n}\n\n.ReactFlipCard--vertical .ReactFlipCard__Back {\n  -webkit-transform: rotateX(180deg);\n  -moz-transform: rotateX(180deg);\n  -ms-transform: rotateX(180deg);\n  -o-transform: rotateX(180deg);\n  transform: rotateX(180deg);\n}\n\n.ReactFlipCard--vertical .ReactFlipCard__Flipper {\n  -webkit-transform-origin: 100% 150px;\n  -moz-transform-origin: 100% 150px;\n  -ms-transform-origin: 100% 150px;\n  -o-transform-origin: 100% 150px;\n  transform-origin: 100% 150px;\n}\n\n/* START: Accommodating for IE */\n.ReactFlipCard--enabled.ReactFlipCard--vertical:hover .ReactFlipCard__Back,\n.ReactFlipCard--vertical.ReactFlipCard--flipped .ReactFlipCard__Back {\n  -webkit-transform: rotateX(0deg);\n  -moz-transform: rotateX(0deg);\n  -ms-transform: rotateX(0deg);\n  -o-transform: rotateX(0deg);\n  transform: rotateX(0deg);\n}\n\n.ReactFlipCard--enabled.ReactFlipCard--vertical:hover .ReactFlipCard__Front,\n.ReactFlipCard--vertical.ReactFlipCard--flipped .ReactFlipCard__Front {\n  -webkit-transform: rotateX(180deg);\n  -moz-transform: rotateX(180deg);\n  -ms-transform: rotateX(180deg);\n  -o-transform: rotateX(180deg);\n  transform: rotateX(180deg);\n}\n/* END: Accommodating for IE */\n";
  }]);
});